import { RadioGroup as BaseRadioGroup } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseRadioGroup)
